import { render, staticRenderFns } from "./ListSettingsButton.vue?vue&type=template&id=9bb8f984&"
import script from "./ListSettingsButton.vue?vue&type=script&lang=js&"
export * from "./ListSettingsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports